import { useEffect, useState } from "react"
import api from "../api/apiInstance"
import { createSmartIdLogin } from "../api/requests/auth"
import { SmartIDLoginResponse } from "../api/requests/interfaces/SmartIDLoginResponse"
import { Spinner } from "../components/common/Spinner"
import { SpinnerContainer } from "../components/common/SpinnerContainer"
import { LoginForm } from "../components/form/LoginForm"
import { SmartIDLoading } from "../components/login/SmartIDLoading"
import { useAppDispatch, useAppSelector } from "../store/hooks"

import bg1 from '../assets/images/backgrounds/rentic_bg_element1.svg';
import bg3 from '../assets/images/backgrounds/rentic_bg_element3.svg';
import { addNotification, NotificationType } from "../store/features/notificationsSlice"
import { Helmet } from "react-helmet-async"

export const LoginPage: React.FC = () => {
    const loginLoading = useAppSelector((state) => state.auth.loading);
    const [smartIdLoading, setSmartIdLoading] = useState(false);
    const [loadingSmartIdRequest, setLoadingSmartIdRequest] = useState(false);
    const [smartIDVerificationCode, setSmartIDVerificationCode] = useState("");
    const dispatch = useAppDispatch();

    const handleCreateSmartIDLogin = async (code: string) => {
        setLoadingSmartIdRequest(true);
        try {
            const res = await createSmartIdLogin({ personalCode: code });
            setSmartIdLoading(true);
            setSmartIDVerificationCode(res.verificationCode);
            setLoadingSmartIdRequest(false);
        } catch {
            dispatch(addNotification({ message: "Smart-ID autentimispäring ebaõnnestus. Proovige hiljem uuesti", type: NotificationType.ERROR }));
            setLoadingSmartIdRequest(false);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="w-full h-full flex justify-center items-center overflow-hidden">

            <Helmet>
                <title>Rentic - Logi sisse</title>
                <meta name="description" content="Loo endale konto ning pane midagi renti või rendi juba täna! Renticus on lai valik erinevatest kategooriatest asju." />
                <meta name="keywords" content="rentic, alusta rentimist, loo Renticu konto, Renticu kasutaja, eseme rent" />
                <meta property="og:title" content="Rentic - Profiil" />
                <meta property="og:description" content="Loo endale konto ning pane midagi renti või rendi juba täna! Renticus on lai valik erinevatest kategooriatest asju." />
                <meta property="og:image" content="https://rentic.ee/logo192.png" />
                <meta property="og:url" content="https://rentic.ee/signup" />
            </Helmet>

            <img className="absolute top-0 left-0 h-[90%] opacity-35 w-auto pointer-events-none" src={bg1} alt="" />
            <img className="absolute top-0 right-0 h-[50%] opacity-25 object-contain object-top w-auto pointer-events-none" src={bg3} alt="" />
            <SpinnerContainer show={loginLoading || loadingSmartIdRequest}>
                <div className="mt-[60px] w-full pb-10 flex justify-center">
                    {
                        !smartIdLoading ?
                            <LoginForm handleSmartIdLoginPress={(code) => handleCreateSmartIDLogin(code)} />
                            :
                            <SmartIDLoading code={smartIDVerificationCode} type={"AUTHENTICATION"} />
                    }
                </div>
            </SpinnerContainer>
        </div>
    )
}